import React from "react";

export default function NavigationButtons() {
  const handleClickGeneralInfo = () => document.getElementById("CH_geninfo").scrollIntoView();
  const handleClickContacts = () => document.getElementById("CH_contacts").scrollIntoView();
  const handleClickAddresses = () => document.getElementById("CH_address").scrollIntoView();

  return (
    <div
      id="tabs"
      className="btn-group panel"
      role="group"
      aria-label="Select the button to go directly to that section of the page"
    >
      <button className="btn-small navigation-button" onClick={handleClickGeneralInfo}>
        General Info
      </button>
      <button className="btn-small navigation-button" onClick={handleClickContacts}>
        Contacts
      </button>
      <button className="btn-small navigation-button" onClick={handleClickAddresses}>
        Addresses
      </button>
    </div>
  );
}
